var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.link && !_vm.button)?_c('span',[_c('a',{attrs:{"href":""},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_vm._v(" "),(_vm.button)?_c('span',[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.download}},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f333950","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailAttachmentDownload.vue
// module id = 1241
// module chunks = 1